import img01 from '../../images/safadinha_alpha.jpg';
import img02 from '../../images/02.jpg';
import img03 from '../../images/03.jpg';

export const items = [
    {
        image: img01,
        title: "",
        position: "center 45%" // altura individual

    },
    {
        image: img03,
        title: "",
        position: "center 70%" // pessoas
    },
    {
        image: img02,
        title: "",
        position: " center 20%" // altura individual
    },
    {
        image: img03,
        title: "",
        position: "center 20%" // altura individual
    }
    
    
    
    
];